import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceAgentStudioRoute: InvariantJiraRoute = {
	name: 'csm-experience-agent-studio',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/agent',
	exact: true,
};
